skrilla.service('betService', function(){
    const deriveOdds =  function(bet){
        const odds = (bet.potentialPayout / bet.stake)
        return (bet.stakeSource === 'PROMOTION_USER' ? odds + 1 : odds).toFixed(3)
    }

    return {
        deriveOdds,
    };
});